import {call, put, takeLatest} from 'redux-saga/effects';
import ApiUtil from "src/utils/ApiUtil";
import {
    getProgramFeesQueryFailedAction,
    getProgramFeesQuerySuccessAction,
    PROGRAM_FEES_QUERY_START,
    ADDITIONAL_PROGRAM_FEES_QUERY_START,
    UPDATE_PROGRAM_FEES_QUERY_START,
    ProgramFeesQueryStartAction
} from "src/actions/ProgramFeesQueryAction";


export function* getProgramFees(action: ProgramFeesQueryStartAction) {
    try {
        let parameters;
        if (action.programParamMap != undefined) {
            parameters = {
                countryCode: action.countryCode,
                itemInfo: action.queryProduct,
                programIdList: action.programIdList,
                programParamMap: action.programParamMap
            }
        } else {
            parameters = {
                countryCode: action.countryCode,
                itemInfo: action.queryProduct,
                programIdList: action.programIdList,
            };
        }
        // @ts-ignore
        const response = yield call(ApiUtil.postApiWithTimeout, "getfees", parameters);
        if (response.succeed) {
            yield put(getProgramFeesQuerySuccessAction(action.programIdList, response.data));
        } else {
            yield put(getProgramFeesQueryFailedAction(action.programIdList));
        }
    } catch (error) {
        console.error("Call API getfees error" + error)
        yield put(getProgramFeesQueryFailedAction(action.programIdList));
        return;
    }
}

export default function* programFees() {
    yield takeLatest([PROGRAM_FEES_QUERY_START, ADDITIONAL_PROGRAM_FEES_QUERY_START, UPDATE_PROGRAM_FEES_QUERY_START], getProgramFees);
}
